import React from 'react'
import { Container, Row, Col, Badge } from 'react-bootstrap'
import groupBy from 'lodash/groupBy'
import isFunction from 'lodash/isFunction'
import isArray from 'lodash/isArray'
import uniqBy from 'lodash/uniqBy'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { enableReorder, APPConfig } from 'config/appConfig'
import {
  i18nTranslate,
  convertToBoolean,
  isFeatureEnabled,
  application,
  currencyFormat,
  getLocalStorage,
  setLocalStorage,
  isB2BAccount,
  getBundleReorderInfo,
  modifyAndGetCustomerType,
  modifyAndGetAccountType,
  displayOrderReturnForSupportedLocales,
  getLiveEventStatus,
  getWebAvailableChannel,
  stripCurrencySymbol,
  isEligibleToShowPVCVSV,
  getIsDisablePVCVSVPriceForAccount,
  tryJSONParse,
  notAllowDangerousGoodsToCart,
} from 'src/utils'
import {
  orderHistoryContainer,
  customerContainer,
  cartContainer,
} from 'src/models'
import {
  displayLastNameFirst,
  getLocaleCodeFromUrl,
} from 'src/utils/localeUtils'
import { AccordionBlock } from 'src/views/components'
import { OrderSummary } from './OrderSummary'
import { ProductDetails } from './ProductDetails'
import { OrderShippingView } from './OrderShippingView'
import { toastState } from 'src/views/components'
import './styles.scss'
function defaultRenderAccordionHeader(props) {
  const {
    className,
    labelText,
    labelValue,
    labelValueAdd,
    dataTestId,
    dataTestIdForValue,
    accordionClasses,
  } = props
  const classes = className ? className : ''
  const accordionClass = accordionClasses ? accordionClasses : ''
  const addClass =
    labelValueAdd && labelValue != labelValueAdd ? 'strikeThrough' : ''
  return (
    <div
      className={`accordion-block-detail ${accordionClass}`}
      data-testid={dataTestId}
      lg={3}>
      {labelText === 'order details' ? (
        <div
          className={`order-card-header-label m-0 text-capitalize ${classes}`}>
          {labelText}
        </div>
      ) : (
        <label
          className={`order-card-header-label m-0 text-capitalize ${classes}`}>
          {labelText}
        </label>
      )}

      {labelValue && (
        <span className={`pl-1 ${addClass}`} data-testid={dataTestIdForValue}>
          {labelValue}
        </span>
      )}
      {labelValueAdd && labelValue != labelValueAdd && (
        <span className="pl-2">{labelValueAdd} </span>
      )}
    </div>
  )
}

@observer
class OrderCard extends React.Component {
  static defaultProps = {
    name: 'Product Name',
    size: 'Large',
    color: 'Red',
    quantity: '2',
    price: '0.00',
    image: 'https://raderain.sirv.com/T-Giant/Cat_PlainTees_588x400.png',
    orderId: '#123456',
    placedDate: 'Dec 14,2017',
    status: 'Shipped',
  }
  constructor(props) {
    super(props)
  }
  @observable orderItem = {}
  @observable activeOrderItem = -1
  @observable isUserListTypeArrayValue = false

  async componentDidMount() {
    if (!orderHistoryContainer.isGetOrderDetailsApiIsInProgress) {
      await this.getOrderById()
    }
  }

  getOrderById = async () => {
    const orderId = this.props.orderDetails?.orderInfo?.orderDetails?.id || ''
    orderHistoryContainer.isGetOrderDetailsApiIsInProgress = true
    this.orderItem = await orderHistoryContainer.getOrderById(orderId)
    const orderData =
      this.orderItem && this.orderItem?.orderInfo
        ? this.orderItem
        : this.props?.orderDetails
    const orderItems = orderData?.orderInfo?.orderDetails?.orderItems || []
    const payload =
      orderHistoryContainer.getPayloadDataForForeignOrderLimitAPI(orderItems)
    await cartContainer.getForeignOrderLimitRestriction(payload)
    orderHistoryContainer.isGetOrderDetailsApiIsInProgress = false
    return this.orderItem
  }
  replaceCurrencySymbol = (price = '') => {
    const priceStr = String(price || '')
    return stripCurrencySymbol(priceStr)
  }
  getPrice = (custompriceValue = 0, options = {}) => {
    const formattedPrice = currencyFormat({
      price: custompriceValue,
      ...options,
    })
    const formattedCustomPrice = this.replaceCurrencySymbol(formattedPrice)
    return formattedCustomPrice
  }

  getFormattedDate = timeStamp => {
    const dateString = timeStamp ? new Date(timeStamp) : new Date()
    const storeTimeZone =
      this.props.orderDetails?.otherproperties?.storeTimeZone || 'US/Mountain'

    let locale = getLocaleCodeFromUrl({
      at: 'pathParam',
      defaultLocale: 'en_US',
      isReverseType: true,
    })

    locale = locale?.replace('_', '-')

    const formatter = new Intl.DateTimeFormat(locale, {
      timeZone: storeTimeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })

    const formattedDate = formatter.format(dateString)

    return formattedDate

    // switch (locale) {
    //   case 'en-US':
    //     return `${month}-${date}-${year}`
    //   case 'fr-CA':
    //     return `${date}-${month}-${year}`
    //   case 'zh-CN':
    //     return `${date}-${month}-${year}`
    //   default:
    //     return `${month}-${date}-${year}`
    // }
  }
  /**
   *  Function for disabling Reorder button
   * @date 07/12/2023
   * @returns {*} boolean
   */
  checkButtonDisable = orderItems => {
    const nonSellableProductStatus = [
      'replacement',
      'preview product',
      'preview',
      'stopped',
      'discontinued',
      'inactive',
    ]
    const reorderItems = orderItems?.orderInfo?.orderDetails?.orderItems || []

    //Filtering the Single Product Status
    const singleProductStockStatusList =
      reorderItems?.filter(
        stockVal =>
          typeof stockVal?.item?.itemInfo?.sku?.inventory?.toLowerCase() !==
          'undefined'
      ) || []
    const singleProductStockStatus =
      singleProductStockStatusList?.map(stockItems => {
        return stockItems?.item?.itemInfo?.sku?.inventory?.toLowerCase()
      }) || []
    //Filtering the bundle Info
    const { checkIfBundleIsEligible = false, checkForBundleReorder = [] } =
      getBundleReorderInfo(reorderItems) || {}

    const isProductOutofStock =
      singleProductStockStatus?.length > 0
        ? singleProductStockStatus?.every(
            status => status === 'out of stock'
          ) || !this.isUserListTypeArrayValue
        : checkForBundleReorder?.length > 0
          ? !checkIfBundleIsEligible || !this.isUserListTypeArrayValue
          : false

    const reorderChannels = reorderItems.map(channel => {
      if (
        channel?.item?.itemInfo?.otherProperties?.availableChannels?.includes(
          getWebAvailableChannel()
        ) &&
        !nonSellableProductStatus?.includes(
          channel?.item?.itemInfo?.otherProperties?.productStatus?.toLowerCase()
        ) &&
        channel?.item?.itemInfo?.otherProperties?.dangerousGoods === 'false' &&
        notAllowDangerousGoodsToCart()
      ) {
        return false
      }
      return true
    })
    return (
      isProductOutofStock ||
      (reorderChannels?.length > 0 && !reorderChannels?.includes(false)) ||
      false
    )
  }
  /**
   * This Function is called to render Return Button in Order History Page
   * Based on the flag/status we receive from Orders API
   */
  renderReturnButton = () => {
    const {
      nextstatus = [],
      status = [],
      isReturnAllowed = false,
    } = this.props.orderDetails?.orderInfo?.orderDetails || {}
    const enableOnlineReturnMFE =
      convertToBoolean(APPConfig?.getAppConfig()?.enableOnlineReturnMFE) ||
      false
    let disableReturnBtn, hideReturnBtn
    const isEnableReturnButtton = enableOnlineReturnMFE ? isReturnAllowed : true
    if (isEnableReturnButtton) {
      disableReturnBtn = !nextstatus?.includes('Return_Submitted')
      hideReturnBtn =
        !nextstatus?.includes('Return_Submitted') &&
        (status.includes('Return_Submitted') || status.includes('Returned'))
          ? true
          : false
    } else {
      disableReturnBtn = true
      hideReturnBtn = false
    }
    const orderId = this.props.orderDetails?.orderInfo?.orderDetails?.id || ''
    const email = customerContainer.profileResponse?.email || ''

    return (
      <div
        tabIndex="0"
        variant="outline-primary"
        className={`order-return-btn btn btn-outline-primary ${
          disableReturnBtn ? 'disabled' : ''
        } ${hideReturnBtn ? 'hide-return-btn' : ''}`}
        role="button"
        data-testid="qa-order-card-return-button"
        aria-disabled={disableReturnBtn ? 'true' : 'false'}
        onClick={event => this.handleReturn(event, orderId)}
        onKeyDown={event => {
          if (
            (event.key === 'Enter' || event.key === ' ') &&
            !disableReturnBtn
          ) {
            event.preventDefault()
            this.handleReturn(event, orderId, email)
          }
        }}>
        {i18nTranslate('orderHistory.return', 'Return')}
      </div>
    )
  }
  renderReorderButton = () => {
    const orderItems =
      this.props.orderDetails?.orderInfo?.orderDetails?.orderItems || []
    const costCenterId =
      this.props.orderDetails?.customer?.userTracking?.costCenterId || ''
    const orderId = this.props.orderDetails?.orderInfo?.orderDetails?.id || ''
    const disableReorderBtn = this.checkButtonDisable(orderItems) || false
    return (
      <div
        tabIndex="0"
        variant="outline-primary"
        className={`reorder-btn btn btn-outline-primary ${
          disableReorderBtn ? 'disabled' : ''
        }`}
        data-testid="qa-order-card-reorder-button"
        onClick={event =>
          this.handleReOrder(event, orderItems, costCenterId, orderId)
        }
        onKeyDown={event => {
          if (
            (event.key === 'Enter' || event.key === ' ') &&
            !disableReorderBtn
          ) {
            this.handleReOrder(event, orderItems, costCenterId, orderId)
          }
        }}>
        {i18nTranslate('orderHistory.reorder', 'Reorder')}
      </div>
    )
  }

  renderOrderApprovalTitle = () => {
    const dateRequested = this.getFormattedDate(1559634288712)
    return (
      <Row noGutters className="approvals m-0">
        <Col className="col-lg-4">
          {defaultRenderAccordionHeader({
            labelText: i18nTranslate('b2b-orderCard.orderId', 'ID'),
            labelValue: '001',
            dataTestId: '',
            accordionClasses: ' d-flex w-100 spanClassName order-id-value',
          })}
          {defaultRenderAccordionHeader({
            labelText: i18nTranslate('b2b-orderCard.team', 'Team'),
            labelValue: 'Sales Team',
            dataTestId: '',
            accordionClasses: ' d-flex w-100',
            className: 'font-weight-normal',
          })}
          {defaultRenderAccordionHeader({
            labelText: i18nTranslate('b2b-order.userName', 'User'),
            labelValue: 'Aravind.G',
            dataTestId: '',
            accordionClasses: ' d-flex w-100 userTextColor',
            className: 'font-weight-normal',
          })}
        </Col>
        <Col className="col-lg-5">
          {defaultRenderAccordionHeader({
            labelText: i18nTranslate(
              'b2b-orderCard.requestDate',
              'Date Requested'
            ),
            labelValue: dateRequested,
            dataTestId: '',
            accordionClasses: ' d-flex w-100 spanClassName',
          })}
          {defaultRenderAccordionHeader({
            labelText: i18nTranslate(
              'b2b-orderCard.itemNumber',
              'Number of item'
            ),
            labelValue: '4 items',
            dataTestId: '',
            accordionClasses: ' d-flex w-100',
            className: 'font-weight-normal',
          })}
          {defaultRenderAccordionHeader({
            labelText: i18nTranslate(
              'b2b-orderCard.remainingBudget',
              'Remaining Budget'
            ),
            labelValue: '$50000',
            dataTestId: '',
            accordionClasses: ' d-flex w-100 budgetTextColor',
            className: 'font-weight-normal',
          })}
          {defaultRenderAccordionHeader({
            labelText: i18nTranslate('b2b-orderCard.orderTotal', 'Order total'),
            labelValue: '$34234',
            dataTestId: '',
            accordionClasses: ' d-flex w-100 spanClassName',
          })}
        </Col>
        <Col className="accordion-block-header-button-section col-lg-3 text-right">
          {defaultRenderAccordionHeader({
            className: 'order-card-button-with-icon w-100',
            labelText: i18nTranslate(
              'b2b-orderCard.hideDetails',
              'Hide Details'
            ),
            labelValue: '',
            dataTestId: '',
            accordionClasses: ' color: #007bff; d-flex w-100',
          })}
        </Col>
      </Row>
    )
  }
  renderOrderHistoryTitle() {
    const localvalue = getLocalStorage('accountType')
    const isDisablePVCVSVPriceForAccount = getIsDisablePVCVSVPriceForAccount({
      accountType: localvalue,
    })
    const userRole = customerContainer.profileResponse?.userrole
    const { createdTime = '', orderItems = [] } =
      this.props.orderDetails?.orderInfo?.orderDetails || {}
    const orderFinancials =
      this.props.orderDetails?.orderInfo?.orderFinancials || {}
    const orderPromotion = orderFinancials?.priceFacets || {}

    // IOM-433 - Hide returned items from Order History and Reorder
    const quantity = orderItems.reduce((previousValue, currentItem) => {
      return previousValue + currentItem?.item?.itemInfo?.quantity
    }, 0)
    const placedDate = this.getFormattedDate(createdTime)
    const priceInfo = orderFinancials?.orderPriceInfo?.[0] || {}
    let price = 0
    try {
      /**
       * @note
       * As, Backend support is not there, OrderTotal is calculated manually
       */
      if (priceInfo) {
        price =
          priceInfo?.totalSale +
          priceInfo?.tax +
          priceInfo?.otherChargesIncludingTax +
          (priceInfo?.roundOff || 0)
      }
    } catch (e) {
      console.log('catch payment error renderOrderHistoryTitle')
    }
    const isPromotion = orderPromotion ? true : false

    //const CV_PV=get(this.props, 'orderDetails.orderInfo.orderDetails.properties', '')
    //const totalPV = get(this.props, 'orderDetails.orderInfo.orderFinancials.priceFacets.PV.PV', '')
    const totalPVDiscount =
      this.props.orderDetails?.orderInfo?.orderFinancials?.priceFacets?.PV
        ?.PVAfterDiscount || ''
    //const totalCV = get(this.props, 'orderDetails.orderInfo.orderFinancials.priceFacets.CV.CV', '')
    const totalCVDiscount =
      this.props.orderDetails?.orderInfo?.orderFinancials?.priceFacets?.CV
        ?.CVAfterDiscount || ''

    let username =
      this.props.orderDetails?.customer?.userTracking?.firstName || ''

    let pickedByName =
      this.props.orderDetails?.otherproperties?.orderPickedUpBy || ''

    const lastName =
      this.props.orderDetails?.customer?.userTracking?.lastName || ''
    username = displayLastNameFirst()
      ? `${lastName} ${username}`.trim()
      : `${username} ${lastName}`.trim()

    const { orderSource = '', orderType = '' } =
      this.props.orderDetails?.otherproperties || {}
    const orderStatus =
      this.props.orderDetails?.orderInfo?.orderDetails?.orderstatus || ''
    const orderNextStatus =
      this.props.orderDetails?.orderInfo?.orderDetails?.nextstatus?.[0] || ''
    const orderTypeStatus =
      this.props.orderDetails?.orderInfo?.orderDetails?.ordertype || ''
    const showReturnOrderBadge = isFeatureEnabled(
      'showReturnOrderBadgeByOrderType'
    )
    const isCombinedOrder =
      orderSource.toLowerCase() === 'combined' &&
      orderType.toLowerCase().includes('subscription')
    const isSubscriptionOrder =
      orderType.toLowerCase().includes('subscription') || false
    const enableLiveEvent = getLiveEventStatus()
    const isReturnOrder =
      (orderStatus.toLowerCase() === 'return_submitted' &&
        (orderNextStatus.toLowerCase() === 'returned' ||
          orderNextStatus.toLowerCase() === 'return_accepted' ||
          orderNextStatus.toLowerCase() === 'return_submitted' ||
          orderNextStatus.toLowerCase() === 'return_received')) ||
      (showReturnOrderBadge && orderTypeStatus.toLowerCase() === 'return') ||
      orderStatus.toLowerCase() === 'returned'
        ? true
        : false
    return (
      <Row noGutters>
        <Col className="accordion-block-header-title-section paragraph-m">
          {defaultRenderAccordionHeader({
            labelText: (
              <span
                className="order-colon-align paragraph-m"
                data-testid="qa-order-card-order-label">
                {i18nTranslate('orderCard.orderId', 'Order')}:
              </span>
            ),
            labelValue:
              this.props.orderDetails?.orderInfo?.orderDetails?.id || '',
            dataTestId: 'qa-order-details-id-wrapper',
            dataTestIdForValue: 'qa-order-details-id-value',
            accordionClasses: 'order-id-value',
          })}
          {defaultRenderAccordionHeader({
            labelText: (
              <span
                className="order-colon-align"
                data-testid="qa-order-placed-date">
                {i18nTranslate('orderCard.placedDate', 'Placed')}:
              </span>
            ),
            labelValue: placedDate,
            dataTestIdForValue: 'qa-order-date-value',
            dataTestId: 'qa-order-date-wrapper',
          })}
          {defaultRenderAccordionHeader({
            labelText: (
              <span
                className="order-colon-align"
                data-testid="qa-order-user-name-title">
                {i18nTranslate('user.nameHeaing', 'User Name')}:
              </span>
            ),
            labelValue: username,
            dataTestId: 'qa-order-user-name-wrapper',
            dataTestIdForValue: 'qa-order-user-name-value',
            accordionClasses: 'order-id-value',
          })}
          {/* Picked By is not required for now for Live Event*/}
          {/* {enableLiveEvent === 'true' &&
            pickedByName &&
            defaultRenderAccordionHeader({
              labelText: (
                <span className="order-colon-align">
                  {i18nTranslate('event.pickeupBy', 'Picked By')}:
                </span>
              ),
              labelValue: pickedByName,
              dataTestId: 'qa-order-id',
              accordionClasses: 'order-id-value',
            })} */}

          {isB2BAccount() &&
            defaultRenderAccordionHeader({
              labelText: (
                <span
                  className="order-colon-align paragraph-m"
                  data-testid="qa-order-item-count-title">
                  {i18nTranslate('orderCard.itemCount', 'Item Count')}:
                </span>
              ),
              labelValue: quantity,
              dataTestId: 'qa-order-item-count',
              dataTestIdForValue: 'qa-order-item-count-value',
            })}

          {isB2BAccount() &&
            defaultRenderAccordionHeader({
              labelText: (
                <span
                  className="order-colon-align"
                  data-testid="qa-order-total-title">
                  {i18nTranslate('orderCard.total', 'Total')}:
                </span>
              ),
              labelValue: currencyFormat({ price }),
              dataTestId: 'qa-order-total',
              accordionClasses: 'font-weight-bold',
              dataTestIdForValue: 'qa-order-total-value',
            })}
          {isEligibleToShowPVCVSV({ accountType: localvalue }) ? (
            <>
              {isPromotion &&
                isB2BAccount() &&
                defaultRenderAccordionHeader({
                  labelText: (
                    <span
                      className="order-colon-align"
                      data-testid="qa-order-total-pv-title">
                      {i18nTranslate('price.TotalSV', 'Total SV', {
                        nameSpace: 'ssr-resource',
                      })}
                      :
                    </span>
                  ),
                  labelValue: this.getPrice(totalPVDiscount, { isPVCV: true }),
                  dataTestId: 'qa-order-totalpv',
                  dataTestIdForValue: 'qa-order-pv-value',
                })}
              {isPromotion &&
                isB2BAccount() &&
                userRole !== 'ROLE_ACCOUNT_BUYER_ADMIN' &&
                !isDisablePVCVSVPriceForAccount &&
                defaultRenderAccordionHeader({
                  labelText: (
                    <span
                      className="order-colon-align"
                      data-testid="qa-order-total-cv-title">
                      {i18nTranslate('orderCard.totalCV', 'Total CV')}:
                    </span>
                  ),
                  labelValue: this.getPrice(totalCVDiscount, { isPVCV: true }),
                  dataTestId: 'qa-order-totalcv',
                  dataTestIdForValue: 'qa-order-cv-value',
                })}

              {isCombinedOrder ? (
                <div>
                  <Badge
                    pill
                    variant="danger"
                    data-testid="qa-order-combined-order-title">
                    {i18nTranslate('orderCard.combinedOrder', 'Combined order')}
                  </Badge>
                </div>
              ) : isSubscriptionOrder ? (
                <div>
                  <Badge
                    pill
                    variant="danger"
                    className="subscription-order-badge"
                    data-testid="qa-order-subscription-order-title">
                    {i18nTranslate(
                      'orderCard.subscriptionOrder',
                      'Subscription order'
                    )}
                  </Badge>
                </div>
              ) : isReturnOrder ? (
                <div>
                  <Badge
                    pill
                    variant="success"
                    data-testid="qa-order-return-order-title">
                    {i18nTranslate('orderCard.returnOrder', 'Return Order')}
                  </Badge>
                </div>
              ) : (
                <></>
              )}
            </>
          ) : (
            <>
              {isCombinedOrder ? (
                <div>
                  <Badge
                    pill
                    variant="danger"
                    data-testid="qa-order-combined-order-title">
                    {i18nTranslate('orderCard.combinedOrder', 'Combined order')}
                  </Badge>
                </div>
              ) : isSubscriptionOrder ? (
                <div>
                  <Badge
                    pill
                    variant="danger"
                    className="subscription-order-badge"
                    data-testid="qa-order-subscription-order-title">
                    {i18nTranslate(
                      'orderCard.subscriptionOrder',
                      'Subscription order'
                    )}
                  </Badge>
                </div>
              ) : isReturnOrder ? (
                <div>
                  <Badge
                    pill
                    variant="success"
                    data-testid="qa-order-return-order-title">
                    {i18nTranslate('orderCard.returnOrder', 'Return Order')}
                  </Badge>
                </div>
              ) : (
                <></>
              )}
            </>
          )}
        </Col>
        {enableLiveEvent !== 'true' && (
          <div className="return-button-section d-flex flex-column justify-content-end">
            {!application?.isSmallPhone &&
              displayOrderReturnForSupportedLocales() &&
              this.renderReturnButton()}
          </div>
        )}

        {!application?.isSmallPhone && (
          <Col className="accordion-block-header-button-section d-flex flex-column flex-grow-0 justify-content-between text-right">
            {defaultRenderAccordionHeader({
              className:
                'order-card-button-with-icon text-nowrap mx-2 paragraph-m',
              labelText: i18nTranslate(
                'orderCard.orderDetails',
                'order details'
              ),
              labelValue: '',
              dataTestId: 'qa-order-history-details',
            })}
            {enableReorder &&
              !orderHistoryContainer.otherUsers &&
              enableLiveEvent !== 'true' &&
              this.renderReorderButton()}
          </Col>
        )}
      </Row>
    )
  }

  renderAccordionTitle = () => {
    return this.renderOrderHistoryTitle()
  }

  activeCancelReturnForm = index => {
    this.activeOrderItem = index
  }
  handleReOrder = (event, orderItems, costCenterId, orderId) => {
    this.props.onReorder(event, orderItems, costCenterId, orderId)
  }
  /**
   * This Function is to redirect to the another URL to process the returns
   * with queryparams locale and orderId , also orderId to be prefilled in the fields
   */
  handleReturn = (event, orderId = '') => {
    event.stopPropagation()
    let defaultReturnUrl = APPConfig?.getAppConfig()?.returnNavigationURL
    if (defaultReturnUrl && defaultReturnUrl.includes('/order-returns/steps')) {
      if (this.props.isPBOMOrder) {
        toastState.setToastMessage(
          i18nTranslate(
            'order.pbom.alert',
            'Please contact customer service to process the return for this order.'
          ),
          false
        )
        return
      }
      let currentLocale = getLocaleCodeFromUrl()?.split('_')
      currentLocale =
        '/' +
        currentLocale[1]?.toLowerCase() +
        '/' +
        currentLocale[0]?.toLowerCase()
      let returnUrl =
        `https://${document.domain}${currentLocale}` +
        defaultReturnUrl +
        `&orderId=${orderId}`
      window.open(returnUrl, '_blank')
    } else {
      let locale = getLocaleCodeFromUrl({
        at: 'pathParam',
        defaultLocale: 'en_US',
        isReverseType: true,
      })
      const returnUrl =
        defaultReturnUrl + '?locale=' + locale + '&order=' + orderId
      window.open(returnUrl, '_blank')
    }
  }

  getShippingInfo = shippingInfo => {
    try {
      return JSON.parse(shippingInfo)
    } catch (e) {
      return shippingInfo || {}
    }
  }

  renderProductDetailView = () => {
    const orderData =
      this.orderItem && this.orderItem.orderInfo
        ? this.orderItem
        : this.props?.orderDetails
    const id = orderData?.orderInfo?.orderDetails?.id || ''
    // currency code based on locale in order -- https://jira.skava.net/browse/SECOM-36671
    const locale = orderData?.orderInfo?.orderDetails?.locale || ''

    // IOM-433 - Hide returned items from Order History and Reorder
    // TD-2491 - Showing returned items for orderType=return
    const orderType = orderData?.orderInfo?.orderDetails?.ordertype || ''
    const orderItems =
      orderType.toLowerCase() !== 'return'
        ? orderData?.orderInfo?.orderDetails?.orderItems?.filter(
            item => item?.item?.itemInfo?.status != 'Returned'
          ) || []
        : orderData?.orderInfo?.orderDetails?.orderItems || []

    const groupedItems = groupBy(orderItems, (item = {}) => {
      const shippingAddress = item.shippingInfo?.shippingAddress || {}
      const shippingMethod = item.shippingInfo?.shippingMethod?.name || ''
      const shippingEmail =
        item.shippingInfo?.shippingDetails?.shippingContact?.email || ''
      const shippingCode = item.shippingInfo?.shippingMethod?.code || ''
      return JSON.stringify(
        Object.assign(
          { shippingAddress },
          { shippingMethod },
          { shippingEmail },
          { shippingCode }
        )
      )
    })

    const copyOfGroupedItems = tryJSONParse(JSON.stringify(groupedItems)) || {}
    let groupedBySkuId = []
    Object.entries(copyOfGroupedItems)?.forEach((props, index) => {
      const [shippingInfo = '{}', itemList = []] = props

      const result = itemList.reduce((accumulator, item) => {
        const found = accumulator.find(accItem => {
          const skuIdCheck =
            accItem?.item?.itemInfo?.sku?.skuId ===
            item?.item?.itemInfo?.sku?.skuId
          const statusCheck =
            accItem?.item?.itemInfo?.status === item?.item?.itemInfo?.status
          if (
            accItem?.item?.itemInfo?.productType?.toLowerCase() === 'bundle' &&
            item?.item?.itemInfo?.productType?.toLowerCase() === 'bundle' &&
            skuIdCheck
          ) {
            const accItemSpecialProducts =
              accItem?.item?.itemInfo?.specialProducts
            let accItemSpecialProductsIds = accItemSpecialProducts
              ?.map(specialItem => specialItem?.skuId)
              ?.sort()
            const itemSpecialProducts = item?.item?.itemInfo?.specialProducts
            let itemSpecialProductsIds = itemSpecialProducts
              ?.map(item => item?.skuId)
              ?.sort()
            return (
              JSON.stringify(accItemSpecialProductsIds) ===
              JSON.stringify(itemSpecialProductsIds)
            )
          }
          return skuIdCheck && statusCheck
        })

        if (found && found?.item?.itemInfo?.quantity) {
          found.item.itemInfo.quantity += item?.item?.itemInfo?.quantity || 0
        } else {
          accumulator.push(item)
        }

        return accumulator
      }, [])

      groupedBySkuId = { [shippingInfo]: result }
    })

    const isOrderHistoryPage = id && orderItems?.length > 0 ? true : false
    const productDetailView = Object.entries(groupedBySkuId).map(
      (props, index) => {
        const [shippingInfo, itemList] = props
        const shippingDetails = this.getShippingInfo(shippingInfo)
        let normalItemList = []
        let freeGiftItemList = []
        itemList.map(orderItem => {
          const isGiftItem =
            orderItem?.item?.itemInfo?.otherProperties?.isGiftItem || ''
          if (!isGiftItem) {
            normalItemList.push(orderItem)
          } else {
            freeGiftItemList.push(orderItem)
          }
        })
        const uniqueFreeGiftItemList =
          uniqBy(
            freeGiftItemList,
            freeGift => freeGift?.item?.itemInfo?.sku?.skuId
          ) || []

        const { enableGiftReceipt = false, customGiftMessage = '' } =
          this.props.orderDetails?.otherproperties || {}
        return (
          <React.Fragment key={`order-group-${id}-${index}`}>
            <OrderShippingView
              shippingInfo={shippingDetails}
              orderDetails={orderData}
            />
            {normalItemList.map((order, indexValue) => {
              return (
                <ProductDetails
                  {...this.props}
                  orderItem={order}
                  key={indexValue}
                  orderId={id}
                  getOrderById={this.getOrderById}
                  itemQuantity={order?.item?.itemInfo?.quantity}
                  activeCancelReturnForm={this.activeCancelReturnForm}
                  activeOrderItem={this.activeOrderItem}
                  index={indexValue}
                  locale={locale.replace('_', '-')}
                  isOrderHistory={isOrderHistoryPage}
                />
              )
            })}
            {uniqueFreeGiftItemList.length > 0 && (
              <div
                className="cart-item-category-heading h4 mt-4 text-success"
                data-testid="qa-minicart-title">
                {i18nTranslate('orderCard.freeGifts', 'Free Gifts')}
              </div>
            )}
            {uniqueFreeGiftItemList.map((order, indexVal) => {
              return (
                <ProductDetails
                  {...this.props}
                  orderItem={order}
                  key={indexVal}
                  orderId={id}
                  getOrderById={this.getOrderById}
                  itemQuantity={
                    cartContainer.getCombineFreeGiftQty(
                      order?.item?.itemInfo?.sku?.skuId || '',
                      freeGiftItemList
                    )?.combineFreeGiftQuantity ||
                    order?.item?.itemInfo?.quantity
                  }
                  activeCancelReturnForm={this.activeCancelReturnForm}
                  activeOrderItem={this.activeOrderItem}
                  index={indexVal}
                  locale={locale.replace('_', '-')}
                  isFreeGift={true}
                />
              )
            })}
            {enableGiftReceipt && customGiftMessage && (
              <p className="pt-3">
                <strong>
                  {i18nTranslate('giftMessage', 'Gift Message', {
                    nameSpace: 'ssr-resource',
                  })}
                  :{' '}
                </strong>
                {customGiftMessage}
              </p>
            )}
          </React.Fragment>
        )
      }
    )

    return (
      <Row noGutters>
        <OrderSummary
          orderItem={this.orderItem}
          orderList={orderData}
          getOrderById={this.getOrderById}
          locale={locale.replace('_', '-')}
          renderReorderButton={this.renderReorderButton}
          renderReturnButton={this.renderReturnButton}
        />
        {productDetailView}
      </Row>
    )
  }

  handleAccordionToggle = async params => {
    const orderId = this.props.orderDetails?.orderInfo?.orderDetails?.id

    isFunction(this.props?.toggleAccordionView) &&
      this.props?.toggleAccordionView(orderId)
    if (params?.isOpen) {
      const response = await this.getOrderById()
      let orderSkuList = response.orderInfo?.orderDetails?.orderItems || []
      const orderSkuListArrayValues =
        orderSkuList?.map(orderdetailList => {
          const customerTypeResult =
            modifyAndGetCustomerType(
              orderdetailList?.item?.itemInfo?.otherProperties?.customerTypes
            ) || ''
          const accoutTypeResult =
            modifyAndGetAccountType(
              customerContainer?.profileResponse?.accounts?.accountType
            ) || ''
          return customerTypeResult?.includes(accoutTypeResult) || false
        }) || []
      this.isUserListTypeArrayValue =
        orderSkuListArrayValues?.includes(true) || false
      return response
    }
  }

  renderOrderList = () => {
    const { orderDetails = {}, activeBlockId } = this.props
    const orderId = this.props.orderDetails?.orderInfo?.orderDetails?.id
    const orderItems = orderDetails?.orderInfo?.orderDetails?.orderItems || []
    const productDetailView = this.renderProductDetailView()
    const orderDetailView = isArray(orderItems) && orderItems.length > 0 && (
      <AccordionBlock
        className="mt-2 px-3 py-3 order-accordion-wrapper"
        title={this.renderAccordionTitle()}
        onClick={this.handleAccordionToggle}
        isActive={activeBlockId === orderId}>
        {productDetailView}
      </AccordionBlock>
    )
    return orderDetailView
  }
  render() {
    const orderDetailView = this.renderOrderList()

    // Add 'L!VE 2024' label for Event Store Orders
    const enableLiveEvent = getLiveEventStatus()
    const isEventStoreOrder =
      this.props.orderDetails?.otherproperties?.isEventStore || 'false'
    const addLiveEventLabel = this.props?.addLiveEventLabel || false

    return (
      <Container
        className="order-card-container bg-white px-0 mb-2"
        data-testid="qa-order"
        aria-label="order-details-accodion"
        onClick={() => this.handleAccordionToggle}>
        {isEventStoreOrder === 'true' &&
          addLiveEventLabel &&
          enableLiveEvent !== 'true' && (
            <span className="live-event-order-label">
              {i18nTranslate('event.live2024Logo', 'L!VE 2024')}
            </span>
          )}
        {orderDetailView}
      </Container>
    )
  }
}

export default OrderCard
export { OrderCard }
